import { render, staticRenderFns } from "./ForeignCitationPage.vue?vue&type=template&id=8e73c74a&scoped=true"
import script from "./ForeignCitationPage.vue?vue&type=script&lang=js"
export * from "./ForeignCitationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e73c74a",
  null
  
)

export default component.exports